import { defineMessages } from 'react-intl';

export default defineMessages({
  processed: {
    description: 'label denoting the number of shipment notification emails that were sent',
    defaultMessage: 'Sent',
    id: 'w8j1d9',
  },
  delivered: {
    description: 'label denoting the number of shipment notification emails that were delivered',
    defaultMessage: 'Delivered',
    id: '3A2SNX',
  },
  open: {
    description: 'label denoting the number of shipment notification emails that were opened',
    defaultMessage: 'Opened',
    id: '3PGO7c',
  },
  click: {
    description: 'label denoting the number of shipment notification emails where the link was clicked',
    defaultMessage: 'Clicked Link',
    id: 'PS/Cl9',
  },
});
